import React from 'react'
import styles from './contacts.scss'
import rt from '../reactable.scss'
import {Table, Thead, Th, Tr, Td} from 'components/reactable'
import {ContactNameValue} from './contacts'

import i18n from 'lib/i18n'
const _ = i18n('office')

export default class Contacts extends React.Component {
	static propTypes = {
		contacts: React.PropTypes.array.isRequired,
		onShowContactModal: React.PropTypes.func.isRequired,
		onContactClicked: React.PropTypes.func.isRequired,
	}
	render() {
		const {contacts, onShowContactModal, onContactClicked} = this.props

		if (!contacts) {return false}
		const contactsList = contacts.filter(item => (!item._deleted))
		return (
			<div>
				<div className={rt.tableContainer}>
					<Table
						className={`noPadding`}
						itemsPerPage={7}
						filterable={['contName', 'contAddress', 'contBirthday', 'contPhone', 'contGSM', 'contEmail']}
						sortable={['contName', 'contAddress', 'contBirthday', 'contPhone', 'contGSM', 'contEmail']}
						defaultSort={{
							column: 'contName',
							direction: 'desc',
						}}
						topPaginationElemR={
							<input
								onClick={() => onShowContactModal(null)}
								type="button"
								className="btn green"
								value={_('newContact')}
							/>
								}
					>
						<Thead>
							<Th column="contName">
								<span>{_('name')}</span>
							</Th>
							<Th column="contAddress">
								<span>{_('address')}</span>
							</Th>
							<Th column="contBirthday">
								<span>{_('birthday')}</span>
							</Th>
							<Th column="contPhone">
								<span>{_('phone')}</span>
							</Th>
							<Th column="contGSM">
								<span>{_('gsm')}</span>
							</Th>
							<Th column="contEmail">
								<span>{_('email')}</span>
							</Th>
						</Thead>
						{contactsList.map((item, key) =>
							<Tr key={key} data={item} className="clickable centered" onClick={() => onContactClicked(item._id)}>
								<Td column="contName" data={<ContactNameValue contact={item}/>}/>
								<Td column="contAddress" data={item.address}/>
								<Td column="contBirthday" data={item.birthday}/>
								<Td column="contPhone" data={item.phone}/>
								<Td column="contGSM" data={item.mobile}/>
								<Td column="contEmail" data={item.email}/>
							</Tr>
									)
								}
					</Table>
				</div>
			</div>
		)
	}
}



// WEBPACK FOOTER //
// ./components/office/contactsList.jsx